import CitrusComponentElementList from "./list.js";

const install = function (Vue) {
	Vue.component("CitrusComponentElementList", CitrusComponentElementList);
};

import "citrus.vue.pagination";

const VueCitrusComponentElementList = { CitrusComponentElementList, install};
export default VueCitrusComponentElementList;
export {CitrusComponentElementList, install};
